
import { mapState, mapActions } from "vuex";
import { isEqual } from "lodash";

import RiderDetails from "../common/rider-details-template.vue";
import CancelAndAssignNewRiderDialog from "../dialogs/cancel-and-assign-new-rider-dialog.vue";
import OrderDetailsWaitingForNewRider from "./order-details-waiting-for-new-rider.vue";
export default {
  components: {
    RiderDetails,
    CancelAndAssignNewRiderDialog,
    OrderDetailsWaitingForNewRider
  },
  props: {
    orderDetails: {
      default: () => {},
      typpe: Object
    }
  },
  data() {
    return {
      showCancelAndRequestNewRiderDialog: false,
      loading: false,
      RiderStatuses: [
        { id: "driver_assigned", color: "red", label: "Assigned" },
        { id: "shipped", color: "yellow", label: "Picked up" },
        { id: "complete", color: "green", label: "Delivered" }
      ]
      // initialRiderInfo: null
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    shouldShowDeliveryStatus() {
      return !!(
        this.orderDetails.rider_status &&
        this.isWhatsappAndPorterDelivery &&
        this.isWhatsappOrderAndHomeDelivery
      );
    },
    isWaitingForNewRider() {
      return (
        !this.orderDetails.rider_status && this.showCancelAndRequestNewRider
      );
    },
    isWhatsappAndPorterDelivery() {
      return this.locationDetails?.restaurants?.[0]?.restaurant_platforms?.some(
        (platform) =>
          platform.platform_name === "whatsapp" &&
          platform.delivery_partner === "porter"
      );
    },
    isWhatsappOrderAndHomeDelivery() {
      return (
        this.orderDetails.order_type !==
          this.$constants.OrderTypes.TAKE_AWAY.id &&
        this.getChannelConstObj(this.orderDetails.source).name ===
          this.$constants.Channels.WHATSAPP.name
      );
    },
    isOrderInProcess() {
      return (
        this.orderDetails.status ===
          this.$constants.OrderStatuses.PREPARING.id ||
        this.orderDetails.status ===
          this.$constants.OrderStatuses.READY_FOR_DELIVERY.id
      );
    },

    showCancelAndRequestNewRider() {
      return (
        this.isWhatsappOrderAndHomeDelivery &&
        this.isWhatsappAndPorterDelivery &&
        this.isOrderInProcess
      );
    }
    // isRiderChanged() {
    //   if (!this.orderDetails?.rider_status || !this.initialRiderInfo) {
    //     return false;
    //   }

    //   const currentRider = this.orderDetails.rider_status;
    //   return !isEqual(this.initialRiderInfo, currentRider);
    // }
  },
  // watch: {
  //   "orderDetails.rider_status": {
  //     handler(newRiderStatus) {
  //       if (this.isRiderChanged) {
  //         this.initialRiderInfo = newRiderStatus;
  //       }
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    ...mapActions("reciever", ["cancelAndAssignNewRider"]),
    getRiderStatusConstObj(status) {
      const foundStatus = this.RiderStatuses.find(
        (riderStatus) => riderStatus.id === status
      );
      return (
        foundStatus || {
          color: "grey",
          label: "Unknown Status"
        }
      );
    },
    handleCancelAndRequestNewRiderSubmission(selectedReason) {
      this.loading = true;
      this.cancelAndAssignNewRider({
        orderId: this.orderDetails.id,
        payload: {
          cancel_reason: selectedReason
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.showCancelAndRequestNewRiderDialog = false;
            // if (this.orderDetails.rider_status?.delivery_person_name) {
            //   this.initialRiderInfo = this.orderDetails.rider_status;
            // }
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
